/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {ScrollView} from 'react-native-gesture-handler';
import {px, useIsLandscape} from '../../../../../utils';
import {AppLoadingIndicator} from '../../../../components';
import CustomCard from './CustomCard';

const CardsList = ({
  data,
  onClickRoute,
  cardProps,
  loading,
  disabled,
  selectedId,
}) => {
  const isLandscape = useIsLandscape();

  return (
    <View style={styles.container}>
      {loading ? (
        <AppLoadingIndicator />
      ) : (
        <ScrollView
          style={
            isLandscape
              ? {marginTop: 24, marginLeft: 31}
              : {marginTop: 16, marginLeft: 8, width: '100%'}
          }
          contentContainerStyle={[
            {flexWrap: 'wrap', flexDirection: 'row'},
            isLandscape ? undefined : {justifyContent: 'space-evenly'},
          ]}>
          {data?.map((item, index) => (
            <CustomCard
              isSelected={selectedId !== undefined && selectedId === item.id}
              key={index}
              data={item}
              onClickRoute={onClickRoute}
              cardProps={cardProps}
              disabled={disabled}
            />
          ))}
        </ScrollView>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: px(5),
  },
  contentContainer: {
    justifyContent: 'space-between',
    paddingTop: px(17),
    paddingBottom: px(15),
    backgroundColor: 'white',
  },
});

export default CardsList;
